import EmbedContext from '@/constants/core/EmbedContext'
import baseMixin from './baseMixin'

export default {
  mixins: [baseMixin],
  computed: {
    messagesQueryCandidateId() {
      // NB: `cid` has been kept for backwards compatability but should not be used.
      // It stands for candidateID but since there are also contact messages,
      // this name is ambiguous.
      return this.$route.query.cid || this.$route.query.candidateId || null
    },
    messagesQueryContactId() {
      return this.$route.query.contactId || null
    },
    messagesQueryEmbedContext() {
      return this.$route.query.context || null
    },
    messagesShowCandidateList() {
      switch (this.messagesQueryEmbedContext) {
        case EmbedContext.ReliefRosterCandidateView:
          return false
        default:
          return true
      }
    },
    messagesShowCandidateDetailsToolbar() {
      switch (this.messagesQueryEmbedContext) {
        case EmbedContext.ReliefRosterCandidateView:
          return false
        default:
          return true
      }
    },
    messagesContainerScrollHeight() {
      const contactBarHeight =
        this.isMobileViewPort && this.messagesShowCandidateDetailsToolbar
          ? 111
          : 87
      const devBannerHeight = this.isDev ? 24 : 0
      const topAppBarHeight = this.isEmbedded ? 0 : 76
      const listBarHeight = this.messagesShowCandidateDetailsToolbar ? 64 : 2 // 2px offset to prevent whole page from being scrollable just slightly

      return {
        height: `calc(100vh - ${
          topAppBarHeight + listBarHeight + devBannerHeight + contactBarHeight
        }px)`,
        overflowY: 'auto',
      }
    },
  },
}
